<template>
  <div :style="{width: width}">
    <v-row no-gutters>
      <v-col>
        <date-select
          v-bind="$attrs"
          class="pr-1"
          :label="label"
          :value="date1"
          @input="emitValues($event, date2)"
        />
      </v-col>
      <v-col>
        <date-select
          v-bind="$attrs"
          :label="trans('general.dateTo')"
          :value="date2"
          :placeholder="date1 ? formatDate(date1, 'L') : null"
          @input="emitValues(date1, $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import {DateUtils} from '@/utils/date-utils';
import DateSelect from '@/components/DateSelect';

export default {
  name: 'DatePeriodSelect',
  components: {DateSelect},
  mixins: [
    LocaleUtils,
    DateUtils
  ],
  props: {
    width: {
      default () {
        return 'auto';
      }
    },
    label: {
      type: String
    },
    value: {
      default () {
        return null;
      }
    }
  },
  computed: {
    date1() {
      return Array.isArray(this.value) ? this.value[0] : this.value;
    },
    date2() {
      return Array.isArray(this.value) ? this.value[1] : null;
    },
  },
  methods: {
    emitValues(date1, date2) {
      this.$emit('input', (date1 == null && date2 == null) ? null : [date1, date2]);
    }
  }
}
</script>

<style scoped>
</style>
